export default "__VITE_ASSET__ChmwxiAQ__"